
export const posterMap = {
  tagId: 0,
  backgroundId: 0,
  elementId: 0,
  textStyleId: 0,
  sizeId: 0,
  sizeName: "",
  elementTypeId: 2, // 元素类q型(2:素材banner, 3:头像banner)
  size: {
    width: 375,
    height: 667,
  },
  // 肖像信息
  portraitInfo: {
    teacherName: "",
    isVirtual: false,
    labelStyle: 1,
    showLabelStyle: true,
  },
  bgParameter: {},
  elementImg: "",
  isAiElement: false,
  elementInfo: {
    elementHeight: 250,
    elementWidth: 335,
    offsetX: -1,
    offsetY: 0,
    remainPart: 2,
  },
  // 站点logo详情列表
  logos: [],
  textInfo: {
    textPositionX: -1,
    textPositionY: 57,
    textAlignType: 0,
    lineCount: 2,
  },
  // 内容区方框样式id
  contentStyleId: 0,
  // 内容区方框样式
  contentStyle: {
    bottomBg: "",
    filePath: "",
    repeatBg: "",
  },
};
// 主文字
export const mainText = {
  blockName: "mainText",
  editOptions: {
    subtitle: {
      name: "副标题",
      enName: "subtitle",
      isVali: true,
      labelStyle: "1",
      showLabelStyle: false,
      optionalStyleName: "labelStyleMap",
      text: "",
      min: 0,
      max: 0,
    },
    title: {
      name: "主标题",
      enName: "title",
      isVali: true,
      text: "",
      min: 0,
      max: 0,
    },
  }
}
// 人物卡片
export const characterCard = {
  blockName: "characterCard",
  showName: "人物名片",
  editOptions: {
    floorName: {
      name: "楼层名称",
      enName: "floorName",
      text: "",
      isVali: true,
      min: 4,
      max: 8,
    },
    blockContent: {
      characterImg: {
        name: "人物照片",
        enName: "characterImg",
        src: "",
        size: "60*60",
        storageSize: 500,
        isVali: true,
      },
      characterName: {
        name: "人物姓名",
        enName: "characterName",
        text: "",
        isVali: true,
        min: 2,
        max: 6,
      },
      characterTitle: {
        name: "人物头衔",
        enName: "characterTitle",
        text: "",
        isVali: true,
        min: 2,
        max: 14,
      },
      characterInfo: {
        name: "人物简介",
        enName: "characterInfo",
        text: "",
        isVali: true,
        min: 14,
        max: 42,
      },
    }
  }
}
// 高级图文模块的项
export const advancedImgTextItem = {
  img: {
    name: "图片",
    enName: "img",
    src: "",
    size: "200*200",
    storageSize: 500,
    isVali: true,
  },
  title: {
    name: "标题",
    enName: "title",
    text: "",
    isVali: true,
    min: 2,
    max: 16,
  },
  content: {
    name: "简介",
    enName: "content",
    text: "",
    isVali: true,
    min: 14,
    max: 38,
  },
}
// 高级图文
export const advancedImgText = {
  blockName: "advancedImgText",
  showName: "高级图文",
  editOptions: {
    floorName: {
      name: "楼层名称",
      enName: "floorName",
      text: "",
      isVali: true,
      min: 4,
      max: 8,
    },
    items: []
  }
}
// 富文本模块
export const richText = {
  blockName: "richText",
  showName: "富文本",
  editOptions: {
    floorName: {
      name: "楼层名称",
      enName: "floorName",
      text: "",
      isVali: true,
      min: 4,
      max: 8,
    },
    blockContent: {
      content: {
        name: "内容",
        enName: "content",
        text: "",
        isVali: true,
        min: 0,
        max: 2000,
        inputType: "multiLine"
      }
    }
  }
}
// 普通图文
export const normalImgText = {
  blockName: "normalImgText",
  showName: "普通图文",
  editOptions: {
    floorName: {
      name: "楼层名称",
      enName: "floorName",
      text: "",
      isVali: true,
      min: 4,
      max: 8,
    },
    items: []
  }
}
// 普通图文的项
export const normalImgTextItem = {
  content: {
    name: "内容",
    enName: "content",
    text: "",
    isVali: true,
    min: 6,
    max: 20,
  }
}
// 二维码
export const qrCode = {
  blockName: "qrCode",
  showName: "二维码",
  editOptions: {
    floorName: {
      name: "底部标题",
      enName: "bottomName",
      text: "",
      isVali: true,
      min: 14,
      max: 24,
    },
    blockContent: {
      tip: {
        name: "引导文案",
        enName: "tip",
        text: "",
        isVali: true,
        min: 8,
        max: 10,
      },
      qrImg: {
        name: "二维码",
        enName: "qrImg",
        isVali: true,
        src: "",
        size: "200*200",
        storageSize: 200,
      }
    }
  }
}
// 模块列表
export const posterBlocks = [
  {
    blockName: "normalImgText",
    showName: "普通图文",
    data: normalImgText,
    item: normalImgTextItem,
  },
  {
    blockName: "characterCard",
    showName: "人物卡片",
    data: characterCard
  },
  {
    blockName: "advancedImgText",
    showName: "高级图文",
    data: advancedImgText,
    item: advancedImgTextItem,
  },
  {
    blockName: "richText",
    showName: "富文本",
    data: richText
  }
]
